<template>
  <section class="content" v-if="text">
    <div class="content-inner fading">
      <img alt="Our logo" class="logo" src="/images/butterfields.png" />
      <h1>Welcome to our online memorial designer</h1>
      <div class="intro" v-html="text.introduction"></div>
      <div class="actions">
        <button @click="$router.push('started')" class="button">
          Get started
          <pulse></pulse>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Pulse from "@/components/Pulse.vue"
export default {
  data() {
    return {}
  },
  computed: {
    text() {
      return this.$store.state.text
    }
  },
  components: {
    Pulse
  }
}
</script>

<style scoped>
.content {
  text-align: center;
  display: flex;
  align-items: center;
  min-height: calc(100vh - 5rem);
  width: 100%;
  position: relative;
  z-index: 2;
}
.content-inner {
  width: 90%;
  max-width: 85rem;
  margin: auto;
  padding: 8rem 0;
}
.logo {
  width: 45rem;
  max-width: 50%;
}
@media screen and (max-width: 440px) {
  .content-inner {
    padding-top: 5rem;
  }
}
</style>
